import { render } from "./RemoveShop.vue?vue&type=template&id=00c8ac7a"
import script from "./RemoveShop.vue?vue&type=script&lang=js"
export * from "./RemoveShop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__